<template>
  <div class="dialog-page">
    <transition name="scale-in" @after-leave="closeDialog">
      <div v-if="showContent" class="dialog-container tips-dialog">
        <div class="tips-dialog-wrapper">
          <p class="dialog-title">{{ myTitle }}</p>
          <div
            class="tips-content"
            :class="{ left: textAlign == 'left' }"
            v-html="content"
          ></div>
          <div class="btn-wrap">
            <Button
              class="popup-sure-btn"
              pointClass="j-sure-tip-btn"
              @click="sendConfirmEvt"
            >
              {{ myConfirm }}
            </Button>
          </div>
        </div>
        <Button
          class="close-btn"
          pointClass="j-close-tip-btn"
          @click="hideContent"
        ></Button>
      </div>
    </transition>
    <transition name="fade-in">
      <div v-if="showContent" @click="hideContent" class="dialog-bg"></div>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showContent: false,
      operateType: '',
      confirm: '',
      cancel: '',
      content: '',
      title: '',
      languages: '',
      textAlign: ''
    };
  },
  computed: {
    myTitle() {
      let tips = '';
      try {
        tips = this.title || this.languages.tips.toUpperCase();
      } catch {
        tips = 'tips';
      }
      return tips;
    },
    myConfirm() {
      let confirm = '';
      try {
        confirm = this.confirm || this.languages.confirm.toUpperCase();
      } catch {
        confirm = 'COMFIRM';
      }
      return confirm;
    }
  },
  mounted() {
    this.showContent = true;
  },
  methods: {
    closeDialog() {
      typeof this.onClose === 'function' && this.onClose(); // 关闭的回调
      this.$destroy(true);
      this.$el.parentNode.removeChild(this.$el);
    },
    hideContent() {
      this.showContent = false;
    },
    sendConfirmEvt() {
      typeof this.onConfirm === 'function' && this.onConfirm(); // 按钮的回调
      this.hideContent();
    }
  },
  beforeDestroy() {
    this.showContent = false;
  }
};
</script>

<style scoped lang="scss">
@import '@assets/scss/officialStore/_dimen.scss';
.dialog-page {
  display: flex;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 9999;
  justify-content: center;
  align-items: center;
}
.diaglog-wrapper {
  display: flex;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1001;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
}
.dialog-mask {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 100%;
  height: 100%;
}
.dialog-container {
  position: relative;
  z-index: 10;
  background-size: cover;
  @psetbg ('common-popup.png');
}
.dialog-bg {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 1;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
}
.left {
  text-align: left;
}
.dialog-title {
  margin-top: 32px;
}
.btn-wrap {
  display: flex;
  justify-content: space-around;
  margin: 70px auto 0;
  width: 85%;
}
.popup-sure-btn {
  box-sizing: border-box;
  background-size: cover;
  font-size: 36px;
  color: var(--global-tip-popup-btn);
  @psetbg ('confirm.png');
}
.close-btn {
  position: absolute;
  @psetbg ('close.png');
}
@media screen and (orientation: landscape) {
  .dialog-container {
    position: relative;
    z-index: 10;
    background-size: cover;
    @psetbg ('common-popup-hen.png');
  }
  .btn-wrap {
    margin-top: 37px;
    width: 377px;
    height: 53px;
  }
  .popup-sure-btn {
    font-size: 24px;
    @psetbg ('confirm-hen.png');
  }
  .close-btn {
    // 这里
    position: absolute;
    @psetbg ('close-hen.png');
  }
}
</style>
